import { EnvironmentInterface } from './environment-interface';

export const environment: EnvironmentInterface = {
  frontend_url: 'https://psfdev.alzp.tgscloud.net',
  backend_url: 'https://api.psfdev.alzp.tgscloud.net',
  authentication: {
    clientId: '3bd99e9d-1ffc-4393-8d20-e54b7f65738b',
    authority: 'https://login.microsoftonline.com/329e91b0-e21f-48fb-a071-456717ecc28e',
    scopes: ['api://d08f16f7-28f9-4cec-9e4f-75a333f41827/all'],
    redirectUri: '/',
  },
  awsRum: {
    identityPoolId: 'eu-central-1:0ca89d91-8dc0-44bd-9aa3-098eabe1dd8b',
    applicationId: 'a38c2d65-0fa1-4d39-9aad-682d36848809'
  },
  hotjar: {
    version: -1,
    siteId: -1
  }
};
